import { createSlice, createAction, createAsyncThunk } from '@reduxjs/toolkit'

import { waitForResponse } from '@fairhq/common'

import { isClearAccount } from 'store/helpers/isClearAccount'
import { isClearAll } from 'store/helpers/isClearAll'

import { reportsApi } from './reportsApi'
import { ReportsState, Changelog } from './types'

export const clear = createAction('reports/clear')

export const getBenchmarkOptionsByGroup = createAsyncThunk(
  'reports/getBenchmarkOptionsByGroup',
  async (group: string, { getState }) => {
    const result = await waitForResponse({
      callback: () => reportsApi.getBenchmarkOptionsByGroup(getState, group),
    })

    return { group, benchmarks: result }
  }
)

export const getChangelog = createAsyncThunk(
  'reports/getChangelog',
  async (changelog: Changelog, { getState }) => {
    const result = await waitForResponse({
      callback: () => reportsApi.getChangelog(getState, changelog),
    })

    return {
      result,
      name: `${changelog?.compareFrom}_${changelog?.compareTo}`,
    }
  }
)

const initialState: Partial<ReportsState> = {
  benchmarks: {},
  changelog: {},
}

const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(clear, () => initialState)
      .addCase(getBenchmarkOptionsByGroup.fulfilled, (state, action) => {
        const { group, benchmarks } = action.payload
        if (state.benchmarks) {
          state.benchmarks[group] = benchmarks
        }
      })
      .addCase(getChangelog.fulfilled, (state, action) => {
        if (state.changelog) {
          state.changelog[action.payload.name] = action.payload.result
        }
      })
      .addMatcher(isClearAccount(), () => initialState)
      .addMatcher(isClearAll(), () => initialState)
  },
})

export const { actions: reportsActions, reducer: reportsReducer } = reportsSlice
